export const propFaqBooking = {
  faqEditor: {
    empty: "Noch keine Fragen. Legen Sie die erste an, damit der Agent sie beantworten kann.",
    learnedTooltip: "Antwort durch Selbstlernen des Gastgebers hinzugefügt",
    learnedBadge: "Gelernt",
    removeAttachment: "Anhang entfernen",
    uploading: "Wird hochgeladen…",
    attach: "Anhängen",
    deleteTooltip: "Löschen",
    addQuestion: "Frage hinzufügen",
    qPlaceholder: "Frage · z. B. Gibt es Parkplätze?",
    aPlaceholder: "Antwort · z. B. Ja, kostenlos direkt vor der Tür.",
    errors: {
      fillBeforeAttach: "Geben Sie Frage und Antwort ein, bevor Sie Dateien anhängen.",
      saveBeforeAttach: "Zuerst speichern, um Dateien anzuhängen.",
      uploadFailed: "Die Datei konnte nicht hochgeladen werden.",
      deleteFailed: "Die Datei konnte nicht gelöscht werden.",
    },
  },
  faqSuggestions: {
    title: "Vorschläge zum Lernen",
    intro: "Diese Fragen konnte der Agent nicht beantworten und Sie haben dem Gast geantwortet. Prüfen Sie sie, passen Sie sie bei Bedarf an und speichern Sie sie, damit der Agent sie künftig selbst beantworten kann.",
    askedLabel: "Der Gast fragte",
    questionLabel: "Frage",
    questionPlaceholder: "Wie würden Sie die Frage formulieren?",
    answerLabel: "Antwort des Agenten",
    answerPlaceholder: "Antwort, die der Agent geben wird",
    applyToOthers: "Auch auf andere Einheiten des Inserats anwenden:",
    dismiss: "Verwerfen",
    saveAsAnswer: "Als Antwort speichern",
    errors: {
      saveFailed: "Speichern nicht möglich.",
      dismissFailed: "Verwerfen nicht möglich.",
    },
  },
  sourceNote: {
    title: "Priorität der Antwortquellen des Agenten",
    infoAria: "Prioritätsreihenfolge der Quellen des Agenten ansehen",
    lead: "Wenn zwei Quellen zum selben Detail etwas Unterschiedliches sagen, folgt der Agent dieser Reihenfolge:",
    faqPre: "FAQs ",
    faqStrong: "je einzelner Einheit",
    faqTag: "gewinnt",
    configMain: "Einstellungen der Unterkunft",
    configMuted: "· Zeiten, Kapazität, Services",
    kb: "Wissensdatenbank",
  },
  bookingLinks: {
    title: "So bucht der Gast",
    subPre: "Der Agent sendet Ihren Link für ",
    subStrong: "Direktbuchungen",
    subPost: " und der Gast bucht im Web.",
    step1Pre: "Nennt er eine ",
    step1Strong: "bestimmte Unterkunft",
    step1Post: ", sendet der Agent deren Direktlink.",
    step2Pre: "Gibt es ",
    step2Strong1: "mehrere in dieser Gegend",
    step2Mid: ", ",
    step2Strong2: "listet er jede mit ihrem Link auf",
    step2Post: " plus den globalen Link.",
    step3Pre: "Kennt er die Gegend nicht, ",
    step3Strong: "schlägt er die verfügbaren Gegenden vor",
    step3Post: " und fragt, wo der Gast übernachten möchte.",
    globalLinkLabel: "Globaler Link (alle Standorte)",
    copy: "Kopieren",
    copied: "Kopiert",
    noIdNote: "Der Buchungslink wird erzeugt, sobald für Ihr Konto die Kennung konfiguriert ist.",
    toastCopied: "Link kopiert",
    toastCopyFailed: "Kopieren nicht möglich",
  },
  bookingConfirm: {
    title: "Über neue Buchung informieren",
    subPre: "Wenn eine Buchung bestätigt wird, informieren wir den Gast automatisch ",
    subStrong: "auf WhatsApp",
    subPost: " über die Details seines Aufenthalts.",
    toggleLabel: "Bestätigung auf WhatsApp senden",
    toggleHint: "Wenn Sie dies deaktivieren, wird diese Benachrichtigung nicht an den Gast gesendet. Stammt die Buchung von einer OTA, informiert die OTA ihn.",
    stateOn: "Ja, senden",
    stateOff: "Nicht senden",
    notEditablePre: "Der Inhalt dieser Nachricht ",
    notEditableStrong: "ist derzeit nicht bearbeitbar",
    notEditablePost: ". Wir zeigen Ihnen eine Vorschau dessen, was der Gast erhält.",
    previewTag: "Vorschau · was der Gast sieht",
    online: "online",
    today: "Heute",
    previewHint: "Wird mit Ihrer Konfiguration aktualisiert",
    defaultListingName: "Unterkunft",
    toastEnabled: "Buchungsbenachrichtigung aktiviert",
    toastDisabled: "Buchungsbenachrichtigung deaktiviert",
    toastSaveFailed: "Die Änderung konnte nicht gespeichert werden",
    previewGuest: "Laura García",
    previewBody: "Hallo *{guest}* 👋\n\nIhre Buchung in *{name}* ist bestätigt ✅\n\nBuchungscode: *6233Q1VC5*\nZeitraum: *05/06/2026* – *07/06/2026* 📅\n\nÜber dieses WhatsApp können Sie Ihren Link für den Online-Check-in anfordern und erhalten auch die Anreisehinweise.\nWenn Sie vor oder während Ihres Aufenthalts Hilfe brauchen, schreiben Sie uns hier 💬",
    previewCta: "🇪🇸 Um mit dem Check-in fortzufahren, tippen Sie auf *Ok* oder schreiben Sie *Ok*.",
  },
};
